import './ProductFaq.style';

import { PureComponent } from 'react';

import CustomPagination from 'Component/CustomPagination';
import ShowMore from 'Component/ShowMore';
import Popup from 'Component/Popup';
import Field from 'Component/Field';
import Form from 'Component/Form';
import Html from 'Component/Html';
import Loader from 'Component/Loader';
import { getAllowedFieldsFromProductType } from 'Util/Product/Product';

export const PRODUCT_FAQ_POPUP_ID = 'PRODUCT_FAQ_POPUP_ID';

export default class ProductFaq extends PureComponent {

    getAge(dateString) {
        if (!dateString) return null;
        const [day, month, year] = dateString.split('-');
        // remove '19' as soon as BE implements customization
        const newDateString = [`19${year}`, month, day].join('-');
        const today = new Date();
        const birthDate = new Date(newDateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    getCustomerInterval(dob) {
        const diff_ms = Date.now() - new Date(dob).getTime();
        const age_dt = new Date(diff_ms);
        const age = Math.abs(age_dt.getUTCFullYear() - 1970);
        if (age > 55) {
            return 6;
        } if (age > 45) {
            return 5;
        } else if (age > 35) {
            return 4;
        } else if (age > 30) {
            return 3;
        } else if (age > 25) {
            return 2;
        } else if (age > 20) {
            return 1;
        }

        return 0;
    }

    getLabelFromAttribute(attributeList, value) {
        let attrLabel = '';

        for (const attribute of attributeList) {
            if (value === attribute.value) {
                attrLabel = attribute.label;
            }
        }

        return attrLabel;
    }

    renderAddQuestionForm() {
        const {
            product,
            isSignedIn,
            onQuestionSubmitAttempt,
            onQuestionSubmitSuccess,
            onQuestionError,
            customerAttributes = {},
            questionData: {
                question,
                name,
                email,
                sex: sexQuestion,
                tip_ten: tipTenQuestion,
                tip_par: tipParQuestion,
                age,
                is_private,
                is_agreement,
                is_subscribed
            },
            handleFieldChange
        } = this.props;

        const { sex, tip_par, tip_ten } = customerAttributes;

        let { customer } = this.props;

        if (!customer) {
            customer = {};
        }

        const requiredFields = getAllowedFieldsFromProductType(product.attributes.tip_produs);
        return (
            <Form
              key="forgot-password"
              onSubmit={ onQuestionSubmitAttempt }
              onSubmitSuccess={ onQuestionSubmitSuccess }
              onSubmitError={ onQuestionError }
            >
                <Field
                  block="ProductFaq"
                  elem="QuestionTextArea"
                  id="question"
                  name="question"
                  type="textarea"
                  value={ question }
                  validation={ ['notEmpty'] }
                  mix={ { block: 'ProductFaq', elem: 'Popup-question' } }
                  placeholder={ __('Question') }
                  onChange={ (e) => handleFieldChange("question", e) }
                />
                <div block="Fields" elem="Half">
                    <Field
                        type="text"
                        label={ __('Name') }
                        id="name"
                        name="name"
                        validation={ ['notEmpty', 'lengthBetween2And15'] }
                        value={ isSignedIn ? customer.firstname : name }
                        onChange={ (e) => handleFieldChange("name", e) }
                    />
                    <Field
                        type="email"
                        label={ __('Email') }
                        id="email"
                        name="email"
                        validation={ ['notEmpty', 'lengthEmail'] }
                        value={ isSignedIn ? customer.email : email }
                        onChange={ (e) => handleFieldChange("email", e) }
                    />
                    { sex && requiredFields.sex && (
                            <Field
                            type="select"
                            id="sex"
                            name="sex"
                            label={ __('Gender') }
                            placeholder={ __('Choose') }
                            selectOptions={ sex.attribute_options }
                            validation={ ['notEmpty'] }
                            value={ customer.gender || sexQuestion }
                            onChange={ (e) => handleFieldChange("sex", e) }
                            />
                    ) }
                    { tip_ten && requiredFields.tip_ten && (
                            <Field
                            type="select"
                            label={ __('Skin type') }
                            id="tip_ten"
                            name="tip_ten"
                            placeholder={ __('Choose') }
                            validation={ ['notEmpty'] }
                            selectOptions={ tip_ten.attribute_options }
                            value={ customer.tip_ten || tipTenQuestion }
                            onChange={ (e) => handleFieldChange("tip_ten", e) }
                            />
                    ) }
                    { tip_par && requiredFields.tip_par && (
                        <Field
                            type="select"
                            label={ __('Hair type') }
                            id="tip_par"
                            name="tip_par"
                            placeholder={ __('Choose') }
                            validation={ ['notEmpty'] }
                            selectOptions={ customerAttributes.tip_par.attribute_options }
                            value={ customer.tip_par || tipParQuestion }
                            onChange={ (e) => handleFieldChange("tip_par", e) }
                        />
                    ) }
                    { requiredFields.age && (
                        <Field
                            type="select"
                            id="age"
                            name="age"
                            label={ __('Age') }
                            placeholder={ __('Choose') }
                            selectOptions={ [
                                { label: '16-19', value: 0 },
                                { label: '20-24', value: 1 },
                                { label: '25-29', value: 2 },
                                { label: '30-34', value: 3 },
                                { label: '35-44', value: 4 },
                                { label: '45-54', value: 5 },
                                { label: '55+', value: 6 }
                            ] }
                            validation={ ['notEmpty'] }
                            value={ this.getCustomerInterval(customer.dob) || age }
                            onChange={ (e) => handleFieldChange("age", e) }
                        />
                    ) }
                </div>
                { isSignedIn && (
                    <Field
                        type="checkbox"
                        value={ is_private }
                        label={ __('I wish to receive the answer in private') }
                        id="is_private"
                        name="is_private"
                        onChange={ () => handleFieldChange("is_private", !is_private) }
                    />
                ) }
                <Field
                  type="checkbox"
                  value={ is_agreement }
                  label={ __("I agree to <a href='/page/terms-and-conditions' target='_blank'>terms and conditions</a>") }
                  id="is_agreement"
                  name="is_agreement"
                  validation={ ['checked'] }
                  checked={ is_agreement }
                  onChange={ () => handleFieldChange("is_agreement", !is_agreement) }
                />
                <Field
                  type="checkbox"
                  value={ is_subscribed }
                  label={ __('I wish to subscribe to the Farmec newsletter') }
                  id="is_subscribed"
                  name="is_subscribed"
                  onChange={ () => handleFieldChange("is_subscribed", !is_subscribed) }
                />
                <div block="ProductFaq" elem="Buttons">
                    <button
                      block="Button"
                      mods={ { isPrimary: true } }
                    >
                        { __('Send question') }
                    </button>
                </div>
            </Form>
        );
    }

    renderQuestionItemAttr(item) {
        const {
            sex, age, tip_par, tip_ten
        } = item;

        const { customerAttributes } = this.props;

        return (
            <div block="ProductFaq" elem="Attr">
                { (age || age === 0) && <span>{ __('Age: %s', this.getAgeInterval(age)) }</span> }
                { sex && <span>{ __('Sex: %s', this.getLabelFromAttribute(customerAttributes.sex.attribute_options, sex))}</span> }
                { tip_par && <span>{ __('Hair type: %s', this.getLabelFromAttribute(customerAttributes.tip_par.attribute_options, tip_par)) }</span> }
                { tip_ten && <span>{ __('Skin type: %s', this.getLabelFromAttribute(customerAttributes.tip_ten.attribute_options, tip_ten)) }</span> }
            </div>
        )
    }

    getAgeInterval(age) {
        switch (age) {
        case 0:
            return '16-19';
        case 1:
            return '20-24';
        case 2:
            return '25-29';
        case 3:
            return '30-34';
        case 4:
            return '35-44';
        case 5:
            return '45-54';
        case 6:
            return '+55';
        default:
            return '';
        }
    }

    renderButton() {
        const { showPopup } = this.props;

        return (
            <button
              block="ProductFaq"
              elem="Button"
              mix={ { block: 'Button' } }
              onClick={ showPopup }
            >
                { __('Ask the specialists') }
            </button>
        );
    }

    renderTotalQuestions(totalQuestions) {
        if (!totalQuestions) {
            return null;
        }

        return (
            <div block="ProductFaq" elem="Count">
                {totalQuestions === 1
                    ? __('%s question', totalQuestions)
                    : __('%s questions', totalQuestions)
                }
            </div>
        )
    }

    renderQuestionItem(questions) {
        if (!questions) {
            return null;
        }

        return questions.map((item) => {
            const {
                question_id, name, question, answer
            } = item;

            return (
                <div key={ question_id } block="ProductFaq" elem="Item">
                    <div block="ProductFaq" elem="Data">
                        <strong>{ name }</strong>
                       { this.renderQuestionItemAttr(item) }
                    </div>
                    <div block="ProductFaq" elem="Content">
                        { question && (
                            <div block="ProductFaq" elem="Text">
                                <strong>{ __('Question') }</strong>
                                <Html content = { question } />
                            </div>
                        ) }
                        { answer && (
                            <div block="ProductFaq" elem="Text">
                                <strong>{ __('Answer') }</strong>
                                <Html content = { answer } />
                            </div>
                        ) }
                    </div>
                </div>
            );
        });
    }

    renderPopup() {
        const { isLoading } = this.props;

        return (
            <Popup
              id={ PRODUCT_FAQ_POPUP_ID }
              mix={ { block: 'ProductFaq', elem: 'Popup' } }
            >
                <Loader isLoading={ isLoading } />
                { this.renderAddQuestionForm() }
            </Popup>
        );
    }

    renderPagination() {
        const {
            currentPage,
            selectPage,
            questionList: { total_pages }
        } = this.props;

        if (total_pages === '1') {
            return null;
        }

        return (
            <CustomPagination
              isLoading={ false }
              totalPages={ parseInt(total_pages, 10) }
              currentPage={ currentPage }
              onPageSelect={ selectPage }
            />
        );
    }

    render() {
        const { questionList, code } = this.props;
        const { total_questions, questions } = questionList;

        if (!questionList) {
            return null;
        }

        return (
            <ShowMore mix={ { block: 'ProductFaq' } }>
                <div block="ProductSection" elem="Heading">
                    <h3 block="ProductSection" elem="HeadingTitle">
                        { __('Questions and answers') }
                    </h3>
                    { this.renderButton() }
                    { code === 'default' && <a href='/compania/beauty-advisor/' target='_blank'>Vezi secțiunea Beauty Adviser</a> }
                </div>
                <div block="ProductSection" elem="Content">
                    <div block="ProductFaq">
                        { this.renderTotalQuestions(total_questions) }
                        <div block="ProductFaq" elem="List">
                            { this.renderQuestionItem(questions) }
                        </div>
                    </div>
                    { this.renderPopup() }
                    { this.renderPagination() }
                </div>
            </ShowMore>
        );
    }
}
